import React from "react";
import Loading from "../Loading";
import { getHOCDisplayName } from "Utils";

const AsyncRouteLoading = getComponent => {
  class AsyncComponent extends React.Component {
    isUnmounted = false;
    state = {
      component: null,
    };

    componentWillUnmount() {
      this.isUnmounted = true;
    }

    componentDidMount() {
      if (!this.state.component) {
        getComponent()
          .then(component => {
            AsyncComponent.component = component;
            AsyncComponent.displayName = `WithAsyncComponent${getHOCDisplayName(
              component
            )}`;
            /**
             * This condition is required as sometimes component is unmounted before promise is resolved
             */
            if (!this.isUnmounted) {
              this.setState({ component });
            }
          })
          .catch(e => {
            console.error(e);
            window.location.reload();
          });
      }
    }
    render() {
      const { component: Component } = this.state;
      return Component ? <Component {...this.props} /> : <Loading />;
    }
  }

  return AsyncComponent;
};

export default AsyncRouteLoading;
